/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Description1Inputs */

const zh_accountsettings_description1 = /** @type {(inputs: Accountsettings_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理您的活跃会话和账户安全。`)
};

const en_accountsettings_description1 = /** @type {(inputs: Accountsettings_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your active sessions and account security.`)
};

const es_accountsettings_description1 = /** @type {(inputs: Accountsettings_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestiona tus sesiones activas y la seguridad de tu cuenta.`)
};

/**
* | output |
* | --- |
* | "Manage your active sessions and account security." |
*
* @param {Accountsettings_Description1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_description1 = /** @type {((inputs?: Accountsettings_Description1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Description1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_description1(inputs)
	if (locale === "en") return en_accountsettings_description1(inputs)
	return es_accountsettings_description1(inputs)
});
export { accountsettings_description1 as "accountSettings_description" }